<template>
  <div class="suggestion-record">
    <div class>
      <!--左侧上方搜索框-->
      <div class="searchbox">
          <!-- <form action="#" method="get" class="form-inline form-float"> -->
      <!-- <div class="form-group">
              <label for>停车场:</label>
  
              <el-select
                class="space-parking"
                placeholder="请选择"
                clearable
                filterable
                v-model="search.parkingId"
              >
                <el-option
                  v-for="{ parkingId, parkingName } in parks"
                  :key="parkingId"
                  :value="parkingId"
                  :label="parkingName"
                ></el-option>
              </el-select>
            </div> -->
      <!-- <div class="form-group">
              <label for>统计时间:</label>
              <el-date-picker type="datetimerange"></el-date-picker>
            
            </div> -->
      <!-- <div class="form-group others">
              <span class="search_btn">
                <button
                  @click="searchList"
                  type="button"
                  class="btn btn-primary"
                  id="search_btn"
                >
                  查询
                </button>
              </span>
            </div> -->
      <!-- </form>-->
        </div> 
      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="用户名"
            prop="userName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="手机号"
            prop="userPhone"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌号"
            prop="plateNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车位号"
            prop="placeNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="地址"
            prop="userAddress"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="是否同意"
            prop="isAgree"
          >
            <template slot-scope="scope">
              {{ scope.row.isAgree == "y" ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="创建日期"
            prop="crtTime"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div style="display: flex; justify-content: space-around;align-items: center;">
      <el-button type="primary" @click="onDownloadBtn">导出</el-button>
      <div style="color:red;font-weight: bold;">
        <span>总计:</span>
        <span style="display:inline-block;width:20px;"></span>
        <span>{{ statis['同意'] }}人同意</span>
        <span style="display:inline-block;width:20px;"></span>
        <span>{{ statis['不同意'] }}人不同意</span>
      </div>
     
    </div>
    

    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { shareSuggestion,shareSuggestionStatis} from "@/api/url";

import Page from "@/page/commons/page";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
      },
      tableListData: {
        rows: [],
      },
      statis:{},
      formLabelWidth: "100px",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      this.$get(shareSuggestion(), {
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows.map((record) => {
          return record;
        });
      });
    },
    getStatis(){
      this.$get(shareSuggestionStatis()).then((data) => {
        this.statis=data?.data??{'同意':0,'不同意':0}

      })
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    onDownloadBtn(){
      this.$downloadFileRequest("/api/parking/statisticsTable/statisticsTableExport",{},
      '意见收集'
      );
    }
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
  },

  mounted: async function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
    this.getStatis()
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
            line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.intellidata-device-iorecord img {
  display: inline-block;
  margin-right: 2px;
}
.suggestion-record .list-right {
  height: calc(100vh - 200px);
}
</style>
